import { useEffect, useState } from "react";
import { useRemainingUpdateSeconds } from "../../../lib/custom-hooks";
import { getLanguageDirection, getPrices } from "../../../lib/funcs";
import styles from "./InnerPriceUpdater.module.scss";
import { useLanguage } from "../../../lib/LanguageContext";

function InnerPriceUpdater({
  setInstruments,
  setDepositCurrencies,
  setSelectedDepositCurrency,
}: {
  setInstruments: React.Dispatch<React.SetStateAction<IInstrument[]>>;
  setDepositCurrencies: (depositCurrencies: IDepositCurrency[]) => void;
  setSelectedDepositCurrency: React.Dispatch<
    React.SetStateAction<IDepositCurrency | undefined>
  >;
}) {
  const { languageData } = useLanguage();

  const remainingSeconds: number = useRemainingUpdateSeconds();
  const [loading, setLoading] = useState(true);
  const updatePrices = () => {
    setLoading(true);
    getPrices(false).then((data: any) => {
      if (data && data.success) {
        setInstruments((instruments) =>
          data.currencyPairs.map((cp: IInstrument) => ({
            ...cp,
            show: instruments.some(
              (ins) =>
                cp.DisplaySymbolName === ins.DisplaySymbolName && ins.show
            ),
          }))
        );
        setDepositCurrencies(data.currencyList);
        setSelectedDepositCurrency((dc) => {
          return dc ? { ...dc } : undefined;
        });
      }
    }).catch(() => { setLoading(false); });
  };

  useEffect(() => {
    if(remainingSeconds > 0)
      setLoading(false);
  }, [remainingSeconds]);

  return (
    <div className={[styles.innerPriceUpdater, styles[getLanguageDirection(languageData)]].join(" ")}>
      {loading && remainingSeconds <= 0 ? (
        <span>Updating...</span>
      ) : (
        <button
          onClick={updatePrices}
          disabled={remainingSeconds > 0}
          className="btn btn-link btn-primary"
        >
          {languageData.update_prices}
          {remainingSeconds > 0 ? ` (${remainingSeconds})` : ""}
        </button>
      )}
    </div>
  );
}

export default InnerPriceUpdater;
